// Dependencies
import React, { Component } from 'react';
import { View, FlatList } from 'react-native';
import lodash, { capitalize, upperFirst } from 'lodash';
import PropTypes from 'prop-types';
import { LAYOUT, ORIENTATION } from '../../../config/Constants';
import Utility from '../../../utils/Utility';
// Components
import styles from './styles';
import { LAYOUT_CONFIG } from '../../../config/LayoutConstants/LayoutConfig';
import { DefaultSizeProductCard } from '../../Product';
import { DefaultSizeVariantCard } from '../../variants';
import {
  SmallProductCard,
  LargeProductCard,
} from '../../Product/OtherProducts';
import { SmallVariantCard, LargeVariantCard } from '../../variants/OtherSkus';
import ErrorBoundaryComponent from '../../shared/ErrorBoundaryComponent';
import { FlatListPerformanceView } from '../../../libraries/ReactNativePerformanceShopify';
import { getListSource } from '../../../utils/PerfUtility';

class PersonalisedRail extends Component {
  static Components = {
    DefaultSizeProductCard,
    DefaultSizeVariantCard,
    LargeProductCard,
    SmallProductCard,
    LargeVariantCard,
    SmallVariantCard,
  };

  constructor() {
    super();
    this.viewedIds = [];
  }

  getComponent = (item, index, similarProducts) => {
    if (Utility.isBlank(item)) {
      return null;
    }
    const {
      id,
      size,
      content,
      navigation,
      toggleCartVisibility,
      listName,
      previousScreen,
      onPress,
      toggleUnavailableProductsModal,
      listData,
      showToast,
      listContent,
      listIndex,
      extraEventParameters = {},
    } = this.props;

    if (item === undefined) {
      return null;
    }

    const ContainerComponent =
      PersonalisedRail.Components[
        `${upperFirst(size)}${capitalize(item.type)}Card`
      ];

    if (ContainerComponent === undefined) {
      return null;
    }

    return (
      <ErrorBoundaryComponent
        itemData={item}
        listData={listData}
        screenName={previousScreen}
      >
        <ContainerComponent
          toggleUnavailableProductsModal={toggleUnavailableProductsModal}
          id={item.id || item.productId}
          itemData={item}
          listName={listName}
          listContent={listContent}
          layout={LAYOUT.PERSONALISEDRAIL}
          navigation={navigation}
          size={size}
          type={item.type}
          orientation={ORIENTATION.HORIZONTAL}
          listId={id}
          listData={listData}
          index={index}
          toggleCartVisibility={toggleCartVisibility}
          previousScreen={previousScreen}
          onPress={onPress}
          refreshOfferStrip={this.props.refreshOfferStrip}
          similarProducts={similarProducts}
          showToast={showToast}
          listIndex={listIndex}
          fromPersonalisedPage
          extraEventParameters={extraEventParameters}
        />
      </ErrorBoundaryComponent>
    );
  };

  render() {
    const { feed } = this.props;
    this.displayCount = feed
      ? lodash.max([
          LAYOUT_CONFIG.minRailContForVerticalRail,
          this.props.displayCount || 0,
        ])
      : this.props.displayCount || 0;
    this.itemData = this.props.item.filter((x) => !!x);

    const mainProduct = this.itemData.slice(0, 1);
    const similarProducts = this.itemData.slice(1);
    if (Utility.isBlank(this.itemData)) {
      return null;
    }

    return (
      <View style={styles.container}>
        <FlatList
          data={mainProduct}
          style={styles.flatlistStyle}
          showsHorizontalScrollIndicator={false}
          renderItem={({ item, index }) =>
            this.getComponent(item, index, similarProducts)
          }
          keyExtractor={(item) => `${item.schema}_${item.id}`}
        />
      </View>
    );
  }
}

// PropTypes
PersonalisedRail.propTypes = {
  list: PropTypes.shape({
    objects: PropTypes.array,
  }),
  item: PropTypes.array,
};

export default PersonalisedRail;
